import { types } from "../Actions/types";

const initialState = {
  recentSignUpList: [],
};

const RecentSignUps = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.RECENT_SIGNUPS:
      return {
        ...state,
        recentSignUpList: payload,
      };

    default:
      return state;
  }
};

export default RecentSignUps;
